import API from '@enums/api'
import useSession from '@hooks/useSession'
import { useState, useEffect, useCallback } from 'react'
import { useLocation } from 'wouter'

export interface OrgCollection {
    id: string
    name: string
    orgIds: string[]
    orgAdminIds: string[]
    orgCollectionAdminIds: string[]
}

export default function useOrgCollectionsPage() {
    const session = useSession()!
    const [, setLocation] = useLocation()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)
    const [rows, setRows] = useState<OrgCollection[]>([])

    const fetchOrgCollections = useCallback(async () => {
        try {
            // const response = await fetch('/api/overviews/org-collections', {
            const res = await API.ha.orgs.getOrgCollections()

            if (!res.ok) {
                throw new Error('Failed to fetch org collections')
            }

            const data = res.value

            setRows(data)
        } catch (err) {
            setError('Failed to fetch org collections')
            console.error('Error fetching org collections:', err)
        } finally {
            setLoading(false)
        }
    }, [session.accessToken])

    useEffect(() => {
        fetchOrgCollections()
    }, [fetchOrgCollections])

    const handleDelete = useCallback(
        async (id: string) => {
            try {
                const res = await API.ha.orgs.deleteOrgCollection(id)

                if (!res.ok) {
                    throw new Error('Failed to delete org collection')
                }

                // Refresh the list after successful deletion
                fetchOrgCollections()
            } catch (err) {
                setError('Failed to delete org collection')
                console.error('Error deleting org collection:', err)
            }
        },
        [session.accessToken, fetchOrgCollections]
    )

    const handleEdit = useCallback(
        (id: string) => {
            setLocation(`/edit-org-collection/${id}`)
        },
        [setLocation]
    )

    return {
        loading,
        error,
        rows,
        handleDelete,
        handleEdit,
    }
}
